import { css } from '@emotion/react'
import { Loading, type LoadingProps } from '@ruguoapp/jike-fe-components'

export interface PageLoadingProps extends LoadingProps {
	/**
	 *
	 * 不使用 Fixed 定位
	 * @default false
	 */
	noFixed?: boolean
}

export default function PageLoading({ noFixed = false, ...props }: PageLoadingProps) {
	return (
		<Loading
			css={
				noFixed
					? css`
							transform: scale(1.5);
							display: flex;
							justify-content: center;
							align-items: center;
						`
					: css`
							position: fixed;
							left: 50%;
							top: 50%;
							transform: translate(-50%, -50%) scale(1.5);
							z-index: 0;
						`
			}
			{...props}
		/>
	)
}
